import { Pipe, PipeTransform } from '@angular/core';
import { AuthorisationService } from '../services/auth/authorisation.service';
import { Features } from '../services/auth/features';
import { User } from '../user.interface';

@Pipe({
    name: 'hasFeature',
    standalone: false,
})
export class HasFeaturePipe implements PipeTransform {
    transform(value: Features | Features[], user?: User): boolean {
        if (typeof value === 'object') {
            return AuthorisationService.hasAnyFeature(value, user);
        }
        return AuthorisationService.hasFeature(value, user);
    }
}
